import { render, staticRenderFns } from "./ChangeMovementActionBtn.vue?vue&type=template&id=1b665e79&scoped=true"
import script from "./ChangeMovementActionBtn.vue?vue&type=script&lang=ts"
export * from "./ChangeMovementActionBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b665e79",
  null
  
)

export default component.exports